import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { ToastrService } from "ngx-toastr";
import { AuthentificationService } from "src/service/authentification.service";
import { ROUTES } from "../sidebar/menu.items";

var misc: any = {
  sidebar_mini_active: true
};
@Component({
  selector: "app-auth-navbar",
  templateUrl: "./auth-navbar.component.html",
  styleUrls: ["./auth-navbar.component.scss"]
})
export class AuthNavbarComponent implements OnInit {
  isCollapsed = true;
  public link: string = "";
  private listTitles: any[];
  location: Location;
  public isAuth: boolean;

  constructor(location: Location, public toastr: ToastrService, private router: Router, private authService: AuthentificationService) {
    this.location = location;
  }
  minimizeSidebar() {
    const body = document.getElementsByTagName("body")[0];
    if (body.classList.contains("sidebar-mini")) {
      misc.sidebar_mini_active = true;
    } else {
      misc.sidebar_mini_active = false;
    }
    if (misc.sidebar_mini_active === true) {
      body.classList.remove("sidebar-mini");
      misc.sidebar_mini_active = false;
      this.showSidebarMessage("Sidebar mini deactivated...");
    } else {
      body.classList.add("sidebar-mini");
      this.showSidebarMessage("Sidebar mini activated...");
      misc.sidebar_mini_active = true;
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function() {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function() {
      clearInterval(simulateWindowResize);
    }, 1000);
  }
  showSidebarMessage(message) {
    this.toastr.show(
      '<span data-notify="icon" class="tim-icons icon-bell-55"></span>',
      message,
      {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        toastClass: "alert alert-danger alert-with-icon",
        positionClass: "toast-top-right"
      }
    );
  }
  public getCurrentLink = (): string => this.router.url?.split('/')[2]?.toString();

  ngOnInit() {
    this.listTitles = ROUTES;
    this.isLoggedIn();
  }
  getTitle(): string {
    const title = this.location.prepareExternalUrl(this.location.path());
    if (title.indexOf('?') !== -1) return title.split('/')[2]?.toString().substr(0, title.split('/')[2].indexOf('?'));
    else  return title.split('/')[2]?.toString() || title.split('/')[1]?.toString();
  }

  private isLoggedIn = () => {
    this.authService.userData.subscribe(user => {
      this.isAuth = user ? true : false;
    })
  }

}
